import React, { useEffect } from 'react';
import { Input, Checkbox, Select, ConfigProvider, Form, Button } from 'antd';
import { useFormDataContext } from '../../../contexts/form-data.ctx';
import Text from 'antd/lib/typography/Text';
import { Box } from '../../../../../components/Box';
import { VOTING_VALUES } from '../VotingInput';
import { countries } from '../../../../editor/countries/countries';
import { numbers } from '../../../../editor/numbers/Numbers';
import { Option } from '../../../../../components/Input';
import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import 'moment/locale/sk';
import sk_SK from 'antd/lib/locale/sk_SK';
import moment from 'moment';
import NewOwnerComponent from './NewOwnerComponent'
import OwnerComponent from './OwnerComponent'
import { RenderSeparatedName, renderAddress } from '../../../../../utils/string';
import { TypInyIdentifikatorEnum } from '../../../../admin/pages/Interfaces';
import { translations } from '../../../../../utils/LocalizedStrings';

const defaultKey = 'prevod_podielu_custom'

function ShareTransferSinglePersonComponent({ documentId, name, label = 'Select', ...rest }) {
  const values = useFormDataContext(({ data, setField }) => ({
    value: data[name] === undefined || data[name] === '' ? {} : data[name],
    company: data.company || {},
    userPersons: data.userPersons || [],
    setField
  }));
  const key = defaultKey + "_" + documentId
  const [fieldValues, setFieldValues] = React.useState(values);
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const [edited, setEdited] = React.useState(false);

  const handleChange = async () => {
    await values.setField({
      target: {
        name,
        value: fieldValues.value,
      }
    });
  };

  useEffect(() => {
    if (!fieldValues.value.baseInvestment && values.company && values.company.zakladneImanie) {
      fieldValues.value.baseInvestment = Number(values.company.zakladneImanie.value)
      forceUpdate()
    }
  }, [])

  useEffect(() => {
    let newValues = fieldValues
    for (let [key, entry] of Object.entries(values.value)) {
      if (key !== "baseInvestment") {
        newValues.value[key] = entry
      }
    }
    if (newValues !== fieldValues) {
      setFieldValues(newValues)
    }
    fieldValues.spolocnici = values.spolocnici
  }, [values])

  const changeValue = (e) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    newValues[documentId][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    if (e.target.name === 'dateOfBirth') {
      handleChange()
    }
  };

  const changeOwner = (value) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    newValues[documentId]['owner'] = value
    newValues[documentId]['shareSum'] = fieldValues.value.baseInvestment
    newValues[documentId]['amount'] = "0"
    let spolocnik = getSpolocnik(newValues[documentId]['owner'])
    newValues[documentId]['percentage'] = spolocnik.share
    newValues[documentId]['newOwner'] = { address: { country: "SK" }, separatedName: {} }
    if (spolocnik.type === "ownerCompany") {
      newValues[documentId]['idType'] = spolocnik.idType
      newValues[documentId]['idnumber'] = spolocnik.idNumber
      newValues[documentId].representingPersons = [{}]
    } else {
      let person = spolocnik
      let persons = values.userPersons || []
      let foundPerson
      fieldValues.value = { person: value, type: "ownerPerson", address: person.address, separatedName: person.personName }
      let name = person.personName.name
      let surname = person.personName.surname
      for (let person of persons) {
        if ((person.separatedName.name === name && person.separatedName.surname === surname)) {
          foundPerson = person
          break
        }
      }
      if (foundPerson) {
        newValues[documentId]['idnumber'] = foundPerson.idNumber
        newValues[documentId]['idType'] = foundPerson.idType
        newValues[documentId].dateOfBirth = foundPerson.dateOfBirth
      } else {
        newValues[documentId]['idType'] = undefined
        newValues[documentId]['idnumber'] = undefined
      }
    }
    newValues[documentId].representingPersons = undefined
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    forceUpdate()
  };

  const getSpolocnik = (id) => {
    if (values.company && values.company.spolocnici) {
      for (let spolocnik of values.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
    return {}
  }


  const changePersonSeparatedName = (e) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId]) {
      newValues[documentId] = {}
    }
    if (e.target.name.indexOf('separatedName.') === -1) {
      newValues[documentId].newOwner[e.target.name] = e.target.value
    } else {
      newValues[documentId].newOwner.separatedName[e.target.name.split('.')[1]] = e.target.value ? e.target.value : e.target.checked
    }

    valuesToSet.value = newValues
    if (e.target.name === "type") {
      if (e.target.value === "ownerCompany") {
        newValues[documentId].newOwner.representingPersons = [{}]
        newValues[documentId].newOwner.idType = undefined
      } else {
        newValues[documentId].newOwner.representingPersons = undefined
        newValues[documentId].newOwner.idType = undefined
      }
    }
    setFieldValues(valuesToSet);
    if (e.target.name === 'dateOfBirth') {
      handleChange()
    }
  }

  const addRepresentingPerson = () => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId].representingPersons) {
      newValues[documentId].representingPersons = []
    }
    newValues[documentId].representingPersons.push({})
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const changeRepresentingPerson = (e, index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].representingPersons[index][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    forceUpdate()
  }

  const deleteRepresentingPerson = (index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].representingPersons.splice(index, 1)
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const addNewOwnerRepresentingPerson = () => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    if (!newValues[documentId].newOwner.representingPersons) {
      newValues[documentId].newOwner.representingPersons = []
    }
    newValues[documentId].newOwner.representingPersons.push({})
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const changeNewOwnerRepresentingPerson = (e, index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].newOwner.representingPersons[index][e.target.name] = e.target.value
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    forceUpdate()
  }

  const deleteNewOwnerRepresentingPerson = (index) => {
    let valuesToSet = fieldValues
    let newValues = valuesToSet.value
    newValues[documentId].newOwner.representingPersons.splice(index, 1)
    valuesToSet.value = newValues
    setFieldValues(valuesToSet);
    handleChange()
  }

  const resolvePersons = () => {
    setEdited(false)
    let persons = values.userPersons || []
    let newOwner = {}
    Object.entries(fieldValues.value[documentId]?.newOwner).forEach(([key, value]) => {
      if (key === "idnumber") {
        newOwner.idNumber = value
      } else {
        newOwner[key] = value
      }
    })
    console.log(persons, newOwner)
    let firstName = newOwner.separatedName?.name
    let surname = newOwner.separatedName?.surname
    let type = newOwner.type
    let idNumber = newOwner.idNumber
    if (firstName && surname && type === "ownerPerson") {
      let index = 0
      let foundPerson
      for (let person of persons) {
        if ((person.separatedName.name === firstName && person.separatedName.surname === surname) || person.idNumber === idNumber) {
          foundPerson = person
          break
        }
        index += 1
      }
      if (foundPerson) {
        for (let key of Object.keys(newOwner)) {
          if (newOwner[key]) {
            foundPerson[key] = newOwner[key]
          }
        }
        persons[index] = foundPerson
      } else {
        persons.push(newOwner)
      }
    }
    console.log(persons)
    values.setField({
      userPersons: persons
    });
  }

  const handleOk = (person) => {
    if (person) {
      let newOwner = {}
      Object.entries(person).forEach(([key, value]) => {
        if (key === "idNumber") {
          newOwner.idnumber = value
        } else {
          newOwner[key] = value
        }
      })
      fieldValues.value[documentId].newOwner = newOwner
      forceUpdate()
      handleChange()
    }
  }

  return (

    fieldValues &&
      fieldValues.value &&
      fieldValues.company && fieldValues.company.spolocnici ?
      <>
        <div>
          <Box flex={0.6}>
            <Text strong>{translations.artifacts.ShareTransferSinglePerson.capital}</Text>
            <Input
              name="baseInvestment"
              onBlur={handleChange}
              placeholder={translations.artifacts.ShareTransferSinglePerson.capital}
              onChange={(e) => {
                fieldValues.value.baseInvestment = e.target.value
                setFieldValues(fieldValues)
                forceUpdate()
              }}
              value={fieldValues.value.baseInvestment ? fieldValues.value.baseInvestment : ""}
            />
          </Box>
        </div>
        <OwnerComponent valueKey={key} singlePerons={true} spolocnik={fieldValues.value[documentId] && getSpolocnik(fieldValues.value[documentId].owner)} documentId={documentId} fieldValues={fieldValues} handleChange={handleChange} changeValueCallback={changeValue} changeOwnerCallback={changeOwner} />
        {fieldValues.value[documentId] && fieldValues.value[documentId].owner && getSpolocnik(fieldValues.value[documentId].owner).type === "ownerCompany" &&
          <form
            id={'repre-'}
            className="fullGridRow shareTransferSinglePerson">
            <Box flex={1} className="rwdWidth" style={{ textAlign: 'center', marginTop: 20 }}>
              <Button
                id={key + "_reprePersonButton"}
                onClick={addRepresentingPerson}
                type="primary"
                className="addPersonButton">
                <PlusOutlined />
                {translations.artifacts.ShareTransferSinglePerson.addRepresentMan}
              </Button>
            </Box>
            {fieldValues.value[documentId].representingPersons && fieldValues.value[documentId].representingPersons.map((representingPerson, representingPersonIndex) => {
              return (
                <div style={{ margin: '10px 0' }}>
                  <Box className="personHeaderTitle">
                    <Text strong>
                      {translations.artifacts.ShareTransferSinglePerson.representManSeller + (representingPersonIndex + 1)}
                    </Text>
                    <div className="personDivider"></div>
                  </Box>
                  <div className="gridRow" style={{ alignItems: 'end' }}>
                    <Box flex={0.6}>
                      <Text strong>{translations.artifacts.ShareTransferSinglePerson.addFunc}</Text>
                      <Input
                        id={key + 'repreFunction' + representingPersonIndex}
                        name="function"
                        onBlur={handleChange}
                        placeholder={translations.artifacts.ShareTransferSinglePerson.func}
                        onChange={(e) => changeRepresentingPerson(e, representingPersonIndex)}
                        value={representingPerson.function ? representingPerson.function : ""}
                      />
                    </Box>
                    <Box flex={0.6}>
                      <Text strong>{translations.artifacts.ShareTransferSinglePerson.addTitleName}</Text>
                      <Input
                        id={key + 'repreName' + representingPersonIndex}
                        name="name"
                        onBlur={handleChange}
                        placeholder={translations.artifacts.ShareTransferSinglePerson.titleName}
                        onChange={(e) => changeRepresentingPerson(e, representingPersonIndex)}
                        value={representingPerson.name ? representingPerson.name : ""}
                      />
                    </Box>
                    <Button
                      onClick={() =>
                        deleteRepresentingPerson(representingPersonIndex)
                      }
                      disabled={fieldValues.value[documentId].representingPersons.length === 1}
                      type="primary"
                      className="removeButton"
                    >
                      <MinusOutlined />
                    </Button>
                  </div>
                </div>
              )
            })

            }
          </form>
        }


        {fieldValues.value[documentId] && fieldValues.value[documentId].newOwner &&
          <>
            <NewOwnerComponent valueKey={key} resolvePersons={resolvePersons} edited={edited} setEdited={setEdited} handleOk={handleOk} percentage={fieldValues.value[documentId].percentage} documentId={documentId} handleChange={handleChange} changePersonSeparatedName={(e) => changePersonSeparatedName(e)} newOwner={fieldValues.value[documentId].newOwner} parentId={name} />
            {fieldValues.value[documentId] && fieldValues.value[documentId].newOwner && fieldValues.value[documentId].newOwner.type === "ownerCompany" &&
              <form
                id={'repre-'}
                className="fullGridRow shareTransferSinglePerson">
                <Box flex={1} className="rwdWidth" style={{ textAlign: 'center', marginTop: 20 }}>
                  <Button
                    id={key + "_repreNewButton"}
                    onClick={addNewOwnerRepresentingPerson}
                    type="primary"
                    className="addPersonButton">
                    <PlusOutlined />
                    {translations.artifacts.ShareTransferSinglePerson.addRepresentMan}
                  </Button>
                </Box>
                {fieldValues.value[documentId].newOwner.representingPersons && fieldValues.value[documentId].newOwner.representingPersons.map((representingPerson, representingPersonIndex) => {
                  return (
                    <div style={{ margin: '10px 0' }}>
                      <Box className="personHeaderTitle">
                        <Text strong>
                          {translations.artifacts.ShareTransferSinglePerson.representMan + (representingPersonIndex + 1)}
                        </Text>
                        <div className="personDivider"></div>
                      </Box>
                      <div className="gridRow" style={{ alignItems: 'end' }}>
                        <Box flex={0.6}>
                          <Text strong>{translations.artifacts.ShareTransferSinglePerson.addFunc}</Text>
                          <Input
                            id={key + 'repreNewFunction' + representingPersonIndex}
                            name="function"
                            onBlur={handleChange}
                            placeholder={translations.artifacts.ShareTransferSinglePerson.func}
                            onChange={(e) => changeNewOwnerRepresentingPerson(e, representingPersonIndex)}
                            value={representingPerson.function ? representingPerson.function : ""}
                          />
                        </Box>
                        <Box flex={0.6}>
                          <Text strong>{translations.artifacts.ShareTransferSinglePerson.addTitleName}</Text>
                          <Input
                            id={key + 'repreNewName' + representingPersonIndex}
                            name="name"
                            onBlur={handleChange}
                            placeholder={translations.artifacts.ShareTransferSinglePerson.titleName}
                            onChange={(e) => changeNewOwnerRepresentingPerson(e, representingPersonIndex)}
                            value={representingPerson.name ? representingPerson.name : ""}
                          />
                        </Box>
                        <Button
                          onClick={() =>
                            deleteNewOwnerRepresentingPerson(representingPersonIndex)
                          }
                          disabled={fieldValues.value[documentId].newOwner.representingPersons.length === 1}
                          type="primary"
                          className="removeButton"
                        >
                          <MinusOutlined />
                        </Button>
                      </div>
                    </div>
                  )
                })

                }
              </form>
            }
          </>
        }

      </>
      :
      <></>
  )
}

function ShareTransferSinglePersonHTMLRenderer(values, documentId) {
  let returnValue = ''
  let uznesenie = ''
  const htmlParser = new DOMParser();
  const virtualHTML = document.createElement('div');
  const getSpolocnik = (id) => {
    if (values.company.spolocnici) {
      for (let spolocnik of values.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    values &&
    values['prevod_podielu_custom'] &&
    values['prevod_podielu_custom'][documentId] &&
    values['company'] &&
    values['company'].spolocnici
  ) {
    let spolocnik = getSpolocnik(values['prevod_podielu_custom'][documentId].owner)

    let currentOwnerShare = `<span class="mention" data-denotation-char=":" data-id="prevod-share" name="share" data-value="Podiel">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Podiel</span>&#xFEFF;</span>`
    let newOwnerAddressPerson = `adresa: <span class="mention" data-denotation-char=":" data-id="prevod-newOwnerAddress-${documentId}" name="address" data-value="Adresa">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Adresa</span>&#xFEFF;</span>`
    let newOwnerAddressCompany = `sídlo: <span class="mention" data-denotation-char=":" data-id="prevod-newOwnerAddress-${documentId}" name="address" data-value="Sídlo">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Sídlo</span>&#xFEFF;</span>`
    let dateOfBirthNewOwner = `, dátum narodenia: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-dateOfBirth-${documentId}" name="dateOfBirth" data-value="Dátum narodenia">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Dátum narodenia</span>&#xFEFF;</span>`
    let newOwnerName = `<span class="mention" data-denotation-char=":" data-id="prevod-newOwnerName-${documentId}" name="name" data-value="Meno">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>Meno</span>&#xFEFF;</span>`
    let idnumberNewOwnerPerson = `${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-idnumber-${documentId}" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType ? TypInyIdentifikatorEnum[values['prevod_podielu_custom'][documentId].newOwner.idType] : "[Doplňte]"}</span>&#xFEFF;</span>`
    let idnumberNewOwnerCompany = `${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === "idNumber" ? "IČO" : "identifikačný údaj"}: <span class="mention" data-denotation-char=":" data-id="prevod-newOwner-idnumber-${documentId}" name="idnumber" data-value="${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === "idNumber" ? "IČO" : "Identifikačný údaj"}">&#xFEFF;<span contenteditable="false"><span class="ql-mention-denotation-char">:</span>${values['prevod_podielu_custom'][documentId].newOwner && values['prevod_podielu_custom'][documentId].newOwner.idType === "idNumber" ? "IČO" : "Identifikačný údaj"}</span>&#xFEFF;</span>`

    returnValue = `<p class="ql-align-justify">Jediný spoločník rozhodol o prevode svojho obchodného podielu o veľkosti 100% na Spoločnosti, ktorému zodpovedá vklad Jediného spoločníka do základného imania Spoločnosti vo výške ${currentOwnerShare} EUR k celkovej výške základného imania Spoločnosti vo výške ${values['prevod_podielu_custom'].baseInvestment ? values['prevod_podielu_custom'].baseInvestment : values.company.zakladneImanie.value} EUR, na nadobúdateľa:`

    returnValue += ` ${newOwnerName}${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? dateOfBirthNewOwner : ""}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? idnumberNewOwnerPerson : idnumberNewOwnerCompany}, ${values['prevod_podielu_custom'][documentId].newOwner.type === "ownerPerson" ? newOwnerAddressPerson : newOwnerAddressCompany}.</p>`
    returnValue += "</br>"
    returnValue += "<p>Jediný spoločník rozhodol o zmene zakladateľskej listiny Spoločnosti v zmysle tohto rozhodnutia a ukladá štatutárnemu orgánu Spoločnosti povinnosť vyhotoviť úplné znenie zakladateľskej listiny Spoločnosti.</p>"

    if (Array.isArray(values.company.spolocnici)) {
      let total = values.company.spolocnici.length
      for (let [key, entry] of Object.entries(values['prevod_podielu_custom'])) {
        if (entry.owner) {
          total -= 1
        }
        if (entry.amount) {
          total += Number(entry.amount)
        }
      }
      if (total > 50) {
        return `<FONT COLOR=red><b>Nový počet podielov prekračuje 50</b></FONT>`
      }
    }


    virtualHTML.append(
      htmlParser.parseFromString(returnValue, 'text/html').body,
    );

    virtualHTML.querySelectorAll('.mention').forEach((artifact) => {
      const key = artifact.getAttribute('name');
      if (values['prevod_podielu_custom'] && values['prevod_podielu_custom'][documentId]) {
        let dataId = artifact.getAttribute('data-id')
        switch (key) {
          case "owner": {
            let spolocnik = getSpolocnik(values['prevod_podielu_custom'][documentId].owner)
            artifact.innerHTML = spolocnik.type === "ownerPerson" ? RenderSeparatedName(spolocnik.separatedName) : spolocnik.fullName
            break
          }
          case "address": {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner.address) {
                let newOwner = values['prevod_podielu_custom'][documentId].newOwner
                artifact.innerHTML = `${newOwner.address.street ? newOwner.address.street : "[Doplňte]"} ${newOwner.address.number ? newOwner.address.number : "[Doplňte]"}, ${newOwner.address.zip ? newOwner.address.zip : "[Doplňte]"} ${newOwner.address.city ? newOwner.address.city : "[Doplňte]"}, ${countries['sk'][newOwner.address.country]}`;
              }
            } else {
              artifact.innerHTML = `${renderAddress(spolocnik.address)}`;
            }
            break
          }
          case "share": {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner.share) {
                artifact.innerHTML = values['prevod_podielu_custom'][documentId].newOwner.share
              }
            } else {
              artifact.innerHTML = values['prevod_podielu_custom'][documentId].shareSum
            }
            break
          }
          case 'name': {
            if (dataId.indexOf("newOwnerName") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner) {
                const spolocnikNew = values['prevod_podielu_custom'][documentId].newOwner
                artifact.innerHTML = spolocnikNew.type === "ownerPerson" ? RenderSeparatedName(spolocnikNew.separatedName) : (spolocnikNew.name ? spolocnikNew.name : "[Doplňte]")
              }
            }
            break;
          }

          default: {
            if (dataId.indexOf("newOwner") !== -1) {
              if (values['prevod_podielu_custom'][documentId].newOwner[key]) {
                artifact.innerHTML = `${values['prevod_podielu_custom'][documentId].newOwner[key]}`
              }
            } else {
              if (values['prevod_podielu_custom'][documentId][key]) {
                artifact.innerHTML = values['prevod_podielu_custom'][documentId][key]
              }
            }
          }
        }

      }
    })

  }

  return returnValue === '' ? "---" : virtualHTML.innerHTML;
}

function ShareTransferValidation(fieldValues, documentId) {
  const getSpolocnik = (id) => {
    if (fieldValues['company'] && fieldValues.company.spolocnici) {
      for (let spolocnik of fieldValues.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    !fieldValues ||
    !fieldValues['prevod_podielu_custom'] ||
    !fieldValues['prevod_podielu_custom'][documentId] ||
    !fieldValues['company'] ||
    !fieldValues['company'].spolocnici
    || !fieldValues['prevod_podielu_custom'][documentId].owner
    || !fieldValues['prevod_podielu_custom'][documentId].percentage
    || !fieldValues['prevod_podielu_custom'][documentId].shareSum
  ) {
    return false
  }
  let spolocnik = getSpolocnik(fieldValues['prevod_podielu_custom'][documentId].owner)
  console.log(spolocnik)
  if (!validateSpolocnik(spolocnik, fieldValues, documentId)) {
    return false
  }
  console.log(fieldValues['prevod_podielu_custom'][documentId].newOwner)
  if (!validateNewOwner(fieldValues['prevod_podielu_custom'][documentId].newOwner)) {
    return false
  }
  console.log("sdkuhdfskufdhskudsfhku")
  return true
}

function validateSpolocnik(spolocnik, fieldValues, documentId) {
  if (!spolocnik || !fieldValues['prevod_podielu_custom'][documentId].idType
    || !fieldValues['prevod_podielu_custom'][documentId].idnumber) {
    return false
  }
  if (spolocnik.type === 'ownerPerson' && (!fieldValues['prevod_podielu_custom'][documentId].dateOfBirth || fieldValues['prevod_podielu_custom'][documentId].dateOfBirth === "Invalid date")) {
    return false
  }
  if (spolocnik.type === 'ownerCompany') {
    if (!fieldValues['prevod_podielu_custom'][documentId].representingPersons || fieldValues['prevod_podielu_custom'][documentId].representingPersons.length < 1) {
      return false
    } else {
      let isValid = true
      fieldValues['prevod_podielu_custom'][documentId].representingPersons.forEach(representingPerson => {
        if (!validateRepresentingPerson(representingPerson)) {
          isValid = false
        }
      })
      return isValid
    }
  }
  return true
}

function validateRepresentingPerson(representingPerson) {
  if (!representingPerson.name || !representingPerson.function) {
    return false
  }
  return true
}

function validateNewOwner(newOwner) {
  if (!newOwner || !newOwner.type || !newOwner.idType || !newOwner.idnumber || !validateAddress(newOwner.address)) {
    return false
  }
  if (newOwner.type === 'ownerPerson') {
    if (!newOwner.dateOfBirth || newOwner.dateOfBirth === "Invalid date") {
      return false
    }
    if (!newOwner.separatedName || !newOwner.separatedName.name || !newOwner.separatedName.surname) {
      return false
    }
  }
  if (newOwner.type === 'ownerCompany') {
    if (!newOwner.name) {
      return false
    }
    if (!newOwner.representingPersons || newOwner.representingPersons.length < 1) {
      return false
    } else {
      let isValid = true
      newOwner.representingPersons.forEach(representingPerson => {
        if (!validateRepresentingPerson(representingPerson)) {
          isValid = false
        }
      })
      return isValid
    }
  }
  return true
}

function validateAddress(address) {
  if (!address || !address.street || !address.city || !address.zip || !address.country || !address.number) {
    return false
  }
  return true
}

function ShareTransferFieldsValidation(fieldValues, documentId) {
  const key = defaultKey + "_" + documentId
  let invalidFields = []
  const getSpolocnik = (id) => {
    if (fieldValues.company && fieldValues.company.spolocnici) {
      for (let spolocnik of fieldValues.company.spolocnici) {
        if (spolocnik.id === id) {
          return spolocnik
        }
      }
    }
  }
  if (
    !fieldValues ||
    !fieldValues['prevod_podielu_custom'] ||
    !fieldValues['prevod_podielu_custom'][documentId] ||
    !fieldValues.company ||
    !fieldValues.company.spolocnici
  ) {
    return [key + "_owner", key + "_idType", key + "_idnumber", key + "_dateOfBirth", key + "_baseInvestment", key + "_shareSum", key + "_percentage"]
  }
  if (!fieldValues.company.zakladneImanie) {
    invalidFields.push(key + "_baseInvestment")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].owner) {
    invalidFields.push(key + "_owner")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].percentage) {
    invalidFields.push(key + "_percentage")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].shareSum) {
    invalidFields.push(key + "_shareSum")
  }
  let spolocnik = getSpolocnik(fieldValues['prevod_podielu_custom'][documentId].owner)
  invalidFields = invalidFields.concat(validateSpolocnikFields(spolocnik, fieldValues, documentId, key))
  invalidFields = invalidFields.concat(validateNewOwnerFields(fieldValues['prevod_podielu_custom'][documentId].newOwner, key))

  return invalidFields
}

function validateSpolocnikFields(spolocnik, fieldValues, documentId, key) {
  let invalidFields = []
  if (!spolocnik) {
    return [key + "_owner", key + "_idType", key + "_idnumber", key + "_dateOfBirth"]
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].idType) {
    invalidFields.push(key + "_idType")
  }
  if (!fieldValues['prevod_podielu_custom'][documentId].idnumber) {
    invalidFields.push(key + "_idnumber")
  }
  if (spolocnik.type === 'ownerPerson' && (!fieldValues['prevod_podielu_custom'][documentId].dateOfBirth || fieldValues['prevod_podielu_custom'][documentId].dateOfBirth === "Invalid date")) {
    invalidFields.push(key + "_dateOfBirth")
  }
  if (spolocnik.type === 'ownerCompany') {
    if (!fieldValues['prevod_podielu_custom'][documentId].representingPersons || fieldValues['prevod_podielu_custom'][documentId].representingPersons.length < 1) {
      invalidFields.push(key + "_reprePersonButton")
    } else {
      let index = 0
      fieldValues['prevod_podielu_custom'][documentId].representingPersons.forEach(representingPerson => {
        if (!representingPerson.name) {
          invalidFields.push(key + "repreName" + index)
        }
        if (!representingPerson.function) {
          invalidFields.push(key + "repreFunction" + index)
        }
        index += 1
      })

    }
  }
  return invalidFields
}

function validateNewOwnerFields(newOwner, key) {
  let invalidFields = []
  if (!newOwner) {
    return [key + "_newOwnerTitlesBefore", key + "_newOwnerType", key + "_newOwnerName", key + "_newOwnerSurname", key + "_newOwnerTitlesAfter", key + "_newOwnerDateOfBirth", key + "_newOwnerIdType", key + "_newOwnerIdNumber", key + "_city", key + "_zip", key + "_street", key + "_country", key + "_number"]
  }
  if (!newOwner.type) {
    invalidFields.push(key + "_newOwnerType")
  }
  if (!newOwner.idType) {
    invalidFields.push(key + "_newOwnerIdType")
  }
  if (!newOwner.idnumber) {
    invalidFields.push(key + "_newOwnerIdNumber")
  }
  if (newOwner.type === 'ownerPerson' || !newOwner.type) {
    if (!newOwner.dateOfBirth || newOwner.dateOfBirth === "Invalid date") {
      invalidFields.push(key + "_newOwnerDateOfBirth")
    }
    if (!newOwner.separatedName) {
      invalidFields.push(key + "_newOwnerName")
      invalidFields.push(key + "_newOwnerSurname")
    } else {
      if (!newOwner.separatedName.name) {
        invalidFields.push(key + "_newOwnerName")
      }
      if (!newOwner.separatedName.surname) {
        invalidFields.push(key + "_newOwnerSurname")
      }
    }
  }
  if (!newOwner.address) {
    invalidFields = invalidFields.concat([key + "_city", key + "_zip", key + "_street", key + "_country", key + "_number"])
  } else {
    if (!newOwner.address.city) {
      invalidFields.push(key + "_city")
    }
    if (!newOwner.address.street) {
      invalidFields.push(key + "_street")
    }
    if (!newOwner.address.number) {
      invalidFields.push(key + "_number")
    }
    if (!newOwner.address.zip) {
      invalidFields.push(key + "_zip")
    }
    if (!newOwner.address.country) {
      invalidFields.push(key + "_country")
    }
  }
  if (newOwner.type === 'ownerCompany') {
    if (!newOwner.name) {
      invalidFields.push(key + "_newOwnerName")
    }
    if (!newOwner.representingPersons || newOwner.representingPersons.length < 1) {
      invalidFields.push(key + "_repreNewButton")
    } else {
      let index = 0
      newOwner.representingPersons.forEach(representingPerson => {
        if (!representingPerson.name) {
          invalidFields.push(key + "repreNewName" + index)
        }
        if (!representingPerson.function) {
          invalidFields.push(key + "repreNewFunction" + index)
        }
        index += 1
      })

    }
  }
  return invalidFields
}

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Mutator: ShareTransferSinglePersonComponent,
  HTMLRenderer: ShareTransferSinglePersonHTMLRenderer,
  Validator: ShareTransferValidation,
  FieldsValidator: ShareTransferFieldsValidation
};
